module.exports = "mutation saveUserGroups($groups:[String]!){saveGroups(groups:$groups){id name}}"